import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  refreshRequired: false,
};

const refreshSlice = createSlice({
  name: 'refresh',
  initialState,
  reducers: {
    setRefreshRequired: (state, action) => {
      state.refreshRequired = action.payload;
    },
  },
});

export const { setRefreshRequired } = refreshSlice.actions;
export default refreshSlice.reducer;
